//import union from 'lodash/union'
import {
  LISTING_REQUEST,
  LISTING_SUCCESS,
  LISTING_FAILURE,
  LISTING_UPDATE_FILTERS,
  LISTING_CLEAR_FILTERS,
  LISTING_COUNT_REQUEST,
  LISTING_COUNT_SUCCESS,
  LISTING_COUNT_FAILURE,
  VIOLATIONS_COUNT_REQUEST,
  VIOLATIONS_COUNT_SUCCESS,
  VIOLATIONS_COUNT_FAILURE,
  VIOLATED_LIST_REQUEST,
  VIOLATED_LIST_SUCCESS,
  VIOLATED_LIST_FAILURE,
  LISTING_IMAGES_REQUEST,
  LISTING_IMAGES_SUCCESS,
  LISTING_IMAGES_FAILURE,
  VIOLATION_TYPES_REQUEST,
  VIOLATION_TYPES_SUCCESS,
  VIOLATION_TYPES_FAILURE,
  LISTING_DETAIL_REQUEST,
  LISTING_DETAIL_SUCCESS,
  LISTING_DETAIL_FAILURE,
  FHAKEYWORDS_REQUEST,
  FHAKEYWORDS_SUCCESS,
  FHAKEYWORDS_FAILURE,
  REMOVE_VIOLATION_REQUEST,
  REMOVE_VIOLATION_SUCCESS,
  REMOVE_VIOLATION_FAILURE,
  ADD_FHAKEYWORD_REQUEST,
  ADD_FHAKEYWORD_SUCCESS,
  ADD_FHAKEYWORD_FAILURE,
  DELETE_FHAKEYWORD_REQUEST,
  DELETE_FHAKEYWORD_SUCCESS,
  DELETE_FHAKEYWORD_FAILURE,
  CORRECTED_LISTING_REQUEST,
  CORRECTED_LISTING_SUCCESS,
  CORRECTED_LISTING_FAILURE,
  UPDATE_EXTRA,
  CLEAR_EXTRA,
  NON_APPROVED_NOTIFICATIONS_REQUEST,
  NON_APPROVED_NOTIFICATIONS_SUCCESS,
  NON_APPROVED_NOTIFICATIONS_FAILURE,
  APPROVE_NOTIFICATION_REQUEST,
  APPROVE_NOTIFICATION_SUCCESS,
  APPROVE_NOTIFICATION_FAILURE,
  BROKER_OVERRIDE_LIST_REQUEST,
  BROKER_OVERRIDE_LIST_SUCCESS,
  BROKER_OVERRIDE_LIST_FAILURE,
  ADD_BROKER_OVERRIDE_REQUEST,
  ADD_BROKER_OVERRIDE_SUCCESS,
  ADD_BROKER_OVERRIDE_FAILURE,
  DELETE_BROKER_OVERRIDE_REQUEST,
  DELETE_BROKER_OVERRIDE_SUCCESS,
  DELETE_BROKER_OVERRIDE_FAILURE,
  BROKER_OVERRIDE_COMPANIES_REQUEST,
  BROKER_OVERRIDE_COMPANIES_SUCCESS,
  BROKER_OVERRIDE_COMPANIES_FAILURE,
  BROKER_OVERRIDE_BROKERS_REQUEST,
  BROKER_OVERRIDE_BROKERS_SUCCESS,
  BROKER_OVERRIDE_BROKERS_FAILURE,
  EDIT_BROKER_OVERRIDE_REQUEST,
  EDIT_BROKER_OVERRIDE_SUCCESS,
  EDIT_BROKER_OVERRIDE_FAILURE,
  FHA_TO_WARNING_REQUEST,
  FHA_TO_WARNING_SUCCESS,
  FHA_TO_WARNING_FAILURE,
  PERSONAL_INFO_WHITE_LIST_REQUEST,
  PERSONAL_INFO_WHITE_LIST_SUCCESS,
  PERSONAL_INFO_WHITE_LIST_FAILURE,
  ADD_PERSONAL_INFO_WHITE_LIST_REQUEST,
  ADD_PERSONAL_INFO_WHITE_LIST_SUCCESS,
  ADD_PERSONAL_INFO_WHITE_LIST_FAILURE,
  DELETE_PERSONAL_INFO_WHITE_LIST_REQUEST,
  DELETE_PERSONAL_INFO_WHITE_LIST_SUCCESS,
  DELETE_PERSONAL_INFO_WHITE_LIST_FAILURE,
} from "actions/listings";

export default (
  state = {
    isFetching: false,
    isLCFetching: false,
    isVCFetching: false,
    isVLFetching: false,
    isLIFetching: false,
    isVTFetching: false,
    isLDFetching: false,
    isFHAKFetching: false,
    isCLFetching: false,
    isRemovingViolation: false,
    violationRemoved: false,
    isAddingKeyword: false,
    keywordAdded: false,
    isDeletingKeyword: false,
    keywordDeleted: false,
    error: undefined,
    listings: [],
    filters: {},
    violatedlistings: [],
    listingimages: [],
    violationtypes: [],
    fhakeywords: [],
    listingdetails: null,
    correctedListings: [],
    extra: {},
    isNANFetching: false,
    nonApprovedNotifications: [],
    isApprovingViolation: false,
    violationApproved: false,
    brokerOverrideLst: [],
    isBOFetching: false,
    isBOAdding: false,
    isBOAdded: false,
    isBODeleting: false,
    isBODeleted: false,
    brokerOverrideCompanyLst: [],
    isBOCFetching: false,
    brokerOverrideBrokerLst: [],
    isBOBFetching: false,
    isBOUpdating: false,
    isBOUpdated: false,
    isConvertingFTW: false,
    isConvertedFTW: false,
    personalInfoWhiteList: [],
    isPIWLFetching: false,
    isPIWLAdding: false,
    isPIWLAdded: false,
    isPIWLDeleting: false,
    isPIWLDeleted: false,
  },
  action
) => {
  switch (action.type) {
    case LISTING_REQUEST:
      return {
        ...state,
        isFetching: true,
        listingdetails: null,
      };
    case LISTING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        listings: action.response.result,
        error: undefined,
      };
    case LISTING_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case LISTING_UPDATE_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.params },
      };
    case LISTING_CLEAR_FILTERS:
      return {
        ...state,
        filters: {},
      };
    case LISTING_COUNT_REQUEST:
      return {
        ...state,
        isLCFetching: true,
      };
    case LISTING_COUNT_SUCCESS:
      return {
        ...state,
        isLCFetching: false,
        error: undefined,
      };
    case LISTING_COUNT_FAILURE:
      return {
        ...state,
        isLCFetching: false,
        error: action.error,
      };
    case VIOLATIONS_COUNT_REQUEST:
      return {
        ...state,
        isVCFetching: true,
        listingdetails: null,
      };
    case VIOLATIONS_COUNT_SUCCESS:
      return {
        ...state,
        isVCFetching: false,
        error: undefined,
      };
    case VIOLATIONS_COUNT_FAILURE:
      return {
        ...state,
        isVCFetching: false,
        error: action.error,
      };
    case VIOLATED_LIST_REQUEST:
      return {
        ...state,
        isVLFetching: true,
        listingdetails: null,
      };
    case VIOLATED_LIST_SUCCESS:
      return {
        ...state,
        isVLFetching: false,
        violatedlistings: action.response.result,
        error: undefined,
      };
    case VIOLATED_LIST_FAILURE:
      return {
        ...state,
        isVLFetching: false,
        error: action.error,
      };
    case LISTING_IMAGES_REQUEST:
      return {
        ...state,
        isLIFetching: true,
      };
    case LISTING_IMAGES_SUCCESS:
      return {
        ...state,
        isLIFetching: false,
        listingimages: action.response.result,
        error: undefined,
      };
    case LISTING_IMAGES_FAILURE:
      return {
        ...state,
        isLIFetching: false,
        error: action.error,
      };
    case VIOLATION_TYPES_REQUEST:
      return {
        ...state,
        isVTFetching: true,
      };
    case VIOLATION_TYPES_SUCCESS:
      return {
        ...state,
        isVTFetching: false,
        violationtypes: action.response.result,
        error: undefined,
      };
    case VIOLATION_TYPES_FAILURE:
      return {
        ...state,
        isVTFetching: false,
        error: action.error,
      };
    case LISTING_DETAIL_REQUEST:
      return {
        ...state,
        isLDFetching: true,
        listingdetails: null,
      };
    case LISTING_DETAIL_SUCCESS:
      return {
        ...state,
        isLDFetching: false,
        listingdetails: action.response,
        error: undefined,
      };
    case LISTING_DETAIL_FAILURE:
      return {
        ...state,
        isLDFetching: false,
        listingdetails: null,
        error: action.error,
      };
    case FHAKEYWORDS_REQUEST:
      return {
        ...state,
        isFHAKFetching: true,
      };
    case FHAKEYWORDS_SUCCESS:
      return {
        ...state,
        isFHAKFetching: false,
        fhakeywords: action.response.result,
        error: undefined,
      };
    case FHAKEYWORDS_FAILURE:
      return {
        ...state,
        isFHAKFetching: false,
        error: action.error,
      };
    case REMOVE_VIOLATION_REQUEST:
      return {
        ...state,
        isRemovingViolation: true,
        violationRemoved: false,
      };
    case REMOVE_VIOLATION_SUCCESS:
      return {
        ...state,
        isRemovingViolation: false,
        violationRemoved: action.response,
        error: undefined,
      };
    case REMOVE_VIOLATION_FAILURE:
      return {
        ...state,
        isRemovingViolation: false,
        violationRemoved: false,
        error: action.error,
      };
    case ADD_FHAKEYWORD_REQUEST:
      return {
        ...state,
        isAddingKeyword: true,
        keywordAdded: false,
      };
    case ADD_FHAKEYWORD_SUCCESS:
      return {
        ...state,
        isAddingKeyword: false,
        keywordAdded: action.response,
        error: undefined,
      };
    case ADD_FHAKEYWORD_FAILURE:
      return {
        ...state,
        isAddingKeyword: false,
        keywordAdded: false,
        error: action.error,
      };
    case DELETE_FHAKEYWORD_REQUEST:
      return {
        ...state,
        isDeletingKeyword: true,
        keywordDeleted: false,
      };
    case DELETE_FHAKEYWORD_SUCCESS:
      return {
        ...state,
        isDeletingKeyword: false,
        keywordDeleted: action.response,
        error: undefined,
      };
    case DELETE_FHAKEYWORD_FAILURE:
      return {
        ...state,
        isDeletingKeyword: false,
        keywordDeleted: false,
        error: action.error,
      };
    case CORRECTED_LISTING_REQUEST:
      return {
        ...state,
        isCLFetching: true,
      };
    case CORRECTED_LISTING_SUCCESS:
      return {
        ...state,
        isCLFetching: false,
        correctedListings: action.response.result,
        error: undefined,
      };
    case CORRECTED_LISTING_FAILURE:
      return {
        ...state,
        isCLFetching: false,
        error: action.error,
      };
    case UPDATE_EXTRA:
      return {
        ...state,
        extra: { ...state.extra, ...action.params },
      };
    case CLEAR_EXTRA:
      return {
        ...state,
        extra: {},
      };
    case NON_APPROVED_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isNANFetching: true,
        listingdetails: null,
      };
    case NON_APPROVED_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isNANFetching: false,
        nonApprovedNotifications: action.response.result,
        error: undefined,
      };
    case NON_APPROVED_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isNANFetching: false,
        error: action.error,
      };
    case APPROVE_NOTIFICATION_REQUEST:
      return {
        ...state,
        isApprovingViolation: true,
        violationApproved: false,
      };
    case APPROVE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isApprovingViolation: false,
        violationApproved: action.response,
        error: undefined,
      };
    case APPROVE_NOTIFICATION_FAILURE:
      return {
        ...state,
        isApprovingViolation: false,
        violationApproved: false,
        error: action.error,
      };
    case BROKER_OVERRIDE_LIST_REQUEST:
      return {
        ...state,
        isBOFetching: true,
      };
    case BROKER_OVERRIDE_LIST_SUCCESS:
      return {
        ...state,
        isBOFetching: false,
        brokerOverrideLst: action.response.result,
        error: undefined,
      };
    case BROKER_OVERRIDE_LIST_FAILURE:
      return {
        ...state,
        isBOFetching: false,
        error: action.error,
      };
    case ADD_BROKER_OVERRIDE_REQUEST:
      return {
        ...state,
        isBOAdding: true,
        isBOAdded: false,
      };
    case ADD_BROKER_OVERRIDE_SUCCESS:
      return {
        ...state,
        isBOAdding: false,
        isBOAdded: true,
        error: undefined,
      };
    case ADD_BROKER_OVERRIDE_FAILURE:
      return {
        ...state,
        isBOAdding: false,
        isBOAdded: false,
        error: action.error,
      };
    case EDIT_BROKER_OVERRIDE_REQUEST:
      return {
        ...state,
        isBOUpdating: true,
        isBOUpdated: false,
      };
    case EDIT_BROKER_OVERRIDE_SUCCESS:
      return {
        ...state,
        isBOUpdating: false,
        isBOUpdated: true,
        error: undefined,
      };
    case EDIT_BROKER_OVERRIDE_FAILURE:
      return {
        ...state,
        isBOUpdating: false,
        isBOUpdated: false,
        error: action.error,
      };
    case DELETE_BROKER_OVERRIDE_REQUEST:
      return {
        ...state,
        isBODeleting: true,
        isBODeleted: false,
      };
    case DELETE_BROKER_OVERRIDE_SUCCESS:
      return {
        ...state,
        isBODeleting: false,
        isBODeleted: true,
        error: undefined,
      };
    case DELETE_BROKER_OVERRIDE_FAILURE:
      return {
        ...state,
        isBODeleting: false,
        isBODeleted: false,
        error: action.error,
      };
    case BROKER_OVERRIDE_COMPANIES_REQUEST:
      return {
        ...state,
        isBOCFetching: true,
      };
    case BROKER_OVERRIDE_COMPANIES_SUCCESS:
      return {
        ...state,
        isBOCFetching: false,
        brokerOverrideCompanyLst: action.response.result,
        error: undefined,
      };
    case BROKER_OVERRIDE_COMPANIES_FAILURE:
      return {
        ...state,
        isBOCFetching: false,
        error: action.error,
      };
    case BROKER_OVERRIDE_BROKERS_REQUEST:
      return {
        ...state,
        isBOBFetching: true,
      };
    case BROKER_OVERRIDE_BROKERS_SUCCESS:
      return {
        ...state,
        isBOBFetching: false,
        brokerOverrideBrokerLst: action.response.result,
        error: undefined,
      };
    case BROKER_OVERRIDE_BROKERS_FAILURE:
      return {
        ...state,
        isBOBFetching: false,
        error: action.error,
      };
    case FHA_TO_WARNING_REQUEST:
      return {
        ...state,
        isConvertingFTW: true,
        isConvertedFTW: false,
      };
    case FHA_TO_WARNING_SUCCESS:
      return {
        ...state,
        isConvertingFTW: false,
        isConvertedFTW: true,
        error: undefined,
      };
    case FHA_TO_WARNING_FAILURE:
      return {
        ...state,
        isConvertingFTW: false,
        isConvertedFTW: false,
        error: action.error,
      };

    case PERSONAL_INFO_WHITE_LIST_REQUEST:
      return {
        ...state,
        isPIWLFetching: true,
      };
    case PERSONAL_INFO_WHITE_LIST_SUCCESS:
      return {
        ...state,
        isPIWLFetching: false,
        personalInfoWhiteList: action.response.result,
        error: undefined,
      };
    case PERSONAL_INFO_WHITE_LIST_FAILURE:
      return {
        ...state,
        isPIWLFetching: false,
        error: action.error,
      };
    case ADD_PERSONAL_INFO_WHITE_LIST_REQUEST:
      return {
        ...state,
        isPIWLAdding: true,
        isPIWLAdded: false,
      };
    case ADD_PERSONAL_INFO_WHITE_LIST_SUCCESS:
      return {
        ...state,
        isPIWLAdding: false,
        isPIWLAdded: true,
        error: undefined,
      };
    case ADD_PERSONAL_INFO_WHITE_LIST_FAILURE:
      return {
        ...state,
        isPIWLAdding: false,
        isPIWLAdded: false,
        error: action.error,
      };
    case DELETE_PERSONAL_INFO_WHITE_LIST_REQUEST:
      return {
        ...state,
        isPIWLDeleting: true,
        isPIWLDeleted: false,
      };
    case DELETE_PERSONAL_INFO_WHITE_LIST_SUCCESS:
      return {
        ...state,
        isPIWLDeleting: false,
        isPIWLDeleted: true,
        error: undefined,
      };
    case DELETE_PERSONAL_INFO_WHITE_LIST_FAILURE:
      return {
        ...state,
        isPIWLDeleting: false,
        isPIWLDeleted: false,
        error: action.error,
      };

    default:
      return state;
  }
};
